<template>
    
    <div :class="col">
		<div :class="[{'without-hover': !event.acf.event_name}, {'active-info': activeState}, 'wrapper-post']" @click="activeState = !activeState">
			<div class="tags">
				<div class="data" v-if="event.acf.event_date" v-html="event.acf.event_date"></div>
				<div class="tag" v-if="event.tag" v-html="event.tag"></div>
			</div>
			<div class="post-photo" :style="{ 'background-image': 'url(' + event.acf.event_image + ')' }"></div>
			<div class="post-info">
				<div class="heading">
					<h4 v-html="event.acf.event_name"></h4>
				</div>
				<div class="description">
					<p v-html="event.acf.event_summary"></p>
					<div class="btn-center">
						<router-link :to="'events/' + event.id">Подробнее</router-link>
					</div>
				</div>
			</div>
		</div>
	</div>
    
</template>

<script>
export default {
    name: 'NewsItem',
    props: ['event', 'col'],
    data() {
        return {
            activeState: false
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/NewsItem/index.vue